import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";
import { stringify } from "qs";

import getReferer from "../shared/helpers/getReferer/getReferer";
import { manageTrackingId, manageSessionId } from "../shared/helpers/tracking";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class TrackingStore {
  trackingData = {
    referer: null,
    trackingId: null,
    sessionId: null,
  };

  constructor(initialData) {
    makeAutoObservable(this);
    this.initialize(initialData);
  }

  initialize(initialData) {
    if (initialData?.refererSource || initialData?.path) {
      this.trackingData.referer = getReferer(
        initialData.path,
        initialData.refererSource,
        isServer
      );
    }

    this.trackingData.trackingId = manageTrackingId();
    this.trackingData.sessionId = manageSessionId();
  }

  get refererQuery() {
    return this.trackingData.referer;
  }

  get refererQueryString() {
    return stringify(this.refererQuery);
  }

  get trackingId() {
    return this.trackingData.trackingId;
  }

  get sessionId() {
    return this.trackingData.sessionId;
  }
}

export default TrackingStore;
